// Angular
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Services
import { AuthenticationService } from 'app/_services/authentication.service';

// 3rd
import { JwtHelperService } from '@auth0/angular-jwt';
import { delayedRetry } from 'app/_helpers/delayedretry.helper';

const RETRY_NUMBER = 5;

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    private jwtHelper: JwtHelperService = new JwtHelperService();

    constructor(
        private authenticationService: AuthenticationService
    ) { }

    private applyCredentials = function (request) {
        const currentUser = this.authenticationService.currentUserValue;

        return request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + currentUser.token)
        });
    };

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = this.authenticationService.currentUserValue;
        const isLoggedIn = currentUser && currentUser.token;
        const isTokenExpired = isLoggedIn ? this.jwtHelper.isTokenExpired(currentUser.token) : false;

        if (isLoggedIn && !isTokenExpired) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        }

        if (isLoggedIn) {
            return next
                .handle(request)
                .pipe(
                    delayedRetry(1000, RETRY_NUMBER),
                    catchError(error => {
                        console.log(error);
                        throw error;
                    }),
                );
        } else {
            return next
                .handle(request);
        }
    }
}
